//----------------------------------------------
//remove single marker
//----------------------------------------------
import { ReinosMaps } from '../../core'

ReinosMaps.prototype.removeMarker = function (mapID, marker_name) {
  const self = this
  let index

  // Find the correct index
  self.markers[mapID].forEach((val, key) => {
    //search the array
    if (val['keys'] !== undefined && index === undefined && val['keys'].includes(marker_name)) {
      index = key
    }
  })

  //remove marker
  if (index !== undefined) {
    self.markers[mapID] = self.markers[mapID].filter((val, key) => index !== key)
  }

  //remove latlng from array
  self.latlngs = self.latlngs.filter((v, key) => key !== index)

  //update markerNumber
  self.markers[mapID] = self.markers[mapID].map((val, key) => {
    val['marker'].markerNumber = key
    val['keys'][0] = key
    return val
  })
}
